import {
CHANGE_AUTH_STATE, SET_DATA, ADD_GROUP_ACCESS, REMOVE_GROUP_ACCESS, CLEAR_GROUP_ACCESS, ADD_USER,
CHANGE_USER_NAME, REMOVE_USER, UPDATE_GROUP, SET_ERROR, CLEAR_ERROR
} from '../actions';
import {store} from '../index';
import {clearError} from '../actions';

var errorTimeout;

const initialState = {
    authState: false,
    users: [],
    groups: [],
    access: [],
    userTypeList: ['promoter', 'customer', 'inspector', 'admin'],
    groupNameList: ['Пригороды', 'Приморский', 'Выборгский', 'Калининский', 'Красногвардейский', 'Невский', 'Фрунзенский',
        'Московский', 'Кировский', 'Красносельский', 'Центр', 'Подъезды', 'Ящики север', 'Ящики юг', 'Ящики пк', 'Визитки',
        'Архив', 'Агенты','Промоутеры', 'Новосибирск', 'Дальний восток', 'Казань', 'Казань-2', 'Казань-3',
        'Юго-Восточный А.О', 'Южный А.О', 'Юго-Западный А.О', 'Западный А.О', 'Северо-Западный А.О', 'Северный А.О', 'Северо-Восточный А.О', 'Восточный А.О', 'Архив МСК'],
    checkedGroupAccess: [],
    filterUsers: [],
    error: undefined
};

function changeAuthState(state, action){
    state.authState = action.payload.authState;
    return {...state};
}

function addGroupAccess(state, action){
    if(state.checkedGroupAccess.indexOf(action.payload.groupAccess) === -1) {
        state.checkedGroupAccess.push(action.payload.groupAccess);
    }
    return {...state};
}

function removeGroupAccess(state, action){
    let index = state.checkedGroupAccess.indexOf(action.payload.groupAccess);
    if(index !== -1) {
        state.checkedGroupAccess.splice(index, 1);
    }
    return {...state};
}

function clearGroupAccess(state){
        state.checkedGroupAccess = [];
    return {...state};
}

function setData(state, action){
    let typeMap = Object.create(null);
    typeMap.localeToOrigin = {
        'Расклейщик': 'promoter',
        'Заказчик': 'customer',
        'Проверяющий': 'inspector',
        'Админ': 'admin'
    };
    typeMap.originToLocale = {
        'promoter': 'Расклейщик',
        'customer': 'Заказчик',
        'inspector': 'Проверяющий',
        'admin': 'Админ'
    };

    state.typeMap = typeMap;

    let data = action.payload.data;
    let filterUsers = [];

    data.users.forEach((user) => {
        user.localeType = typeMap.originToLocale[user.type];

        if(user.type !== 'promoter'){
            filterUsers.push({login: user.login, userName: user.userName, type: user.type});
        }
    });
    filterUsers.sort(sortFilterUsers);
    state.filterUsers = filterUsers;

    data.groups.forEach((group) => {
        let userName;
        data.users.forEach((user) => {
            if(user.login === group.login){
                userName = user.userName;
            }
        });
        if(userName){
            group.userName = userName;
            return false;
        }
    });

    data.access.forEach((access) => {
        let groupNames = [];
        data.users.forEach((user) => {
            if(user.login === access.userLogin){
                access.userName = user.userName;
            } else if(user.login === access.promoterLogin){
                access.promoterName = user.userName;
            }
        });
        data.groups.forEach((group) =>{
            if(access.promoterLogin === group.login){
                if(groupNames.indexOf(group.groupName) === -1){
                    groupNames.push(group.groupName);
                }
            }
        });
        access.groupNames = groupNames;
    });

    state.users = data.users;
    state.groups = data.groups;
    state.access = data.access;

    return {...state};
}

function sortFilterUsers(a, b){
 if(a.userName < b.userName){
     return -1;
 } else if(a.userName > b.userName){
     return 1;
 } else{
     return 0;
 }
}

function addUser(state, action){
    const {login, userName, type} = action.payload;
    if(type !== 'promoter') {
        state.filterUsers.push({userName, login, type});
        state.filterUsers.sort(sortFilterUsers);
        state.filterUsers = [...state.filterUsers];
    }
    return {...state};
}

function changeUserName(state, action){
    console.log('changeUserName');
    const {login, userName, type} = action.payload;
    let userIndex = null;
    for(let i = 0; userIndex === null; i++){
        if(state.users[i].login === login){
            userIndex = i;
        }
    }
    if(userIndex){
        console.log('change user');
        state.users[userIndex].userName = userName;
        state.users = [...state.users];
    }
    if(type === 'promoter') {
        state.groups.forEach((item) => {
            if (item.login === login) {
                item.userName = userName;
            }
        });
            state.groups = [...state.groups];
        }

    state.access.forEach((item) => {
        if(item.userLogin === login){
            item.userName = userName
        } else if(item.promoterLogin === login){
            item.promoterName = userName
        }
        });
    state.access = [...state.access];

    if(type !== 'promoter') {
        state.filterUsers.forEach((item) => {
            if (item.login === login) {
                item.userName = userName;
            }
        });
        state.filterUsers.sort(sortFilterUsers);
        state.filterUsers = [...state.filterUsers];
    }

    return {...state};
}

function setError(state, action){
    state.error = action.payload.error;
    //таймаут для сброса ошибки
    if(errorTimeout){
        clearTimeout(errorTimeout);
    }
    errorTimeout = setTimeout(() => {
        store.dispatch(clearError());
    }, 15000);
    return {...state};
}

function clearErr(state, action){
    state.error = undefined;
    return {...state};
}

function removeUser(state, action){
    const {login, type} = action.payload;
    let userIndex = null;
    for(let i = 0; userIndex === null && i < state.users.length; i++){
        if(state.users[i] && state.users[i].login === login){
            userIndex = i;
        }
    }
    if(userIndex){
        state.users.splice(userIndex, 1);
        state.users = [...state.users];
    }

    if(type === 'promoter'){
        let groupsIdx = [];
        state.groups.forEach((item, index) => {
            if(item.login === login){
                groupsIdx.push(index);
            }
        });
        if(groupsIdx.length){
            let offset = 0;
            // console.log('remove users from groups: ', groupsIdx.length);
            groupsIdx.forEach((index) => {
                state.groups.splice(index - offset++, 1);
            });
        }
        state.groups = [...state.groups];
    }
    let accessIdx = [];
    state.access.forEach((item, index) => {
        if(item.userLogin === login || item.promoterLogin === login){
            accessIdx.push(index);
        }
    });
    if(accessIdx.length){
        let offset = 0;
        // console.log('remove users from access: ', accessIdx.length);
        accessIdx.forEach((index) => {
            state.access.splice(index - offset++, 1);
        });
        state.access = [...state.access];
    }

    if(type !== 'promoter') {
        state.filterUsers.forEach((item, index) => {
            if (item.login === login) {
                state.filterUsers.splice(index, 1);
            }
        });
        state.filterUsers.sort(sortFilterUsers);
        state.filterUsers = [...state.filterUsers];
    }
    return {...state};
}

function updateGroup(state, action){
    console.log('updateGroup');
    const {login, groupName} = action.payload;
    state.access = [...state.access];
    state.access.forEach((access) => {
        if(access.promoterLogin === login){
            if(access.groupNames.indexOf(groupName) === -1){
                access.groupNames.push(groupName);
            } else {
                access.groupNames.splice(access.groupNames.indexOf(groupName), 1);
            }
        }
    });
    return {...state};
}

export default function adminPanelReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_AUTH_STATE:
            return changeAuthState(state, action);
        case SET_DATA:
            return setData(state, action);
        case ADD_GROUP_ACCESS:
            return addGroupAccess(state, action);
        case REMOVE_GROUP_ACCESS:
            return removeGroupAccess(state, action);
        case CLEAR_GROUP_ACCESS:
            return clearGroupAccess(state, action);
        case CHANGE_USER_NAME:
            return changeUserName(state, action);
        case REMOVE_USER:
            return removeUser(state, action);
        case UPDATE_GROUP:
            return updateGroup(state, action);
        case ADD_USER:
            return addUser(state, action);
        case SET_ERROR:
            return setError(state, action);
        case CLEAR_ERROR:
            return clearErr(state, action);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/adminPanelReducer.js